import React, { PureComponent } from 'react'

import Checkbox from 'components/checkbox/checkbox'
import Confirm from 'views/confirm/confirm'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import themeTypes from 'helpers/enums/themes/themeTypes'

class ConfirmCheckbox extends PureComponent {
	constructor() {
		super()
		this.state = {
			checkboxValue: false,
		}
	}

	buildCheckbox() {
		return (
			<div styleName='field'>
				<Checkbox
					value={this.state.checkboxValue}
					onChange={this.handleCheckboxChange}
				/>
				<label styleName={classNames({
					'field-label': true,
				})}>
					{this.props.checkboxLabel}
				</label>
			</div>
		)
	}

	handleCheckboxChange = () => {
		this.setState(prevState => ({
			checkboxValue: !prevState.checkboxValue,
		}))
	}

	handleActionOne = () => {
		this.props.actionOne(this.state.checkboxValue)
	}

	handleActionTwo = () => {
		this.props.actionTwo(this.state.checkboxValue)
	}

	render() {
		return (
			<Confirm
				{...this.props}
				actionTwo={this.handleActionTwo}
				actionOne={this.handleActionOne}
				checkbox={this.buildCheckbox()}
			/>
		)
	}

}

ConfirmCheckbox.propTypes = {
	actionOne: PropTypes.func,
	actionTwo: PropTypes.func,
	checkboxLabel: PropTypes.string,
	theme: PropTypes.oneOf([themeTypes.LIGHT, themeTypes.DARK]),
}

ConfirmCheckbox.defaultProps = {
	actionOne: () => {},
	actionTwo: () => {},
	checkboxLabel: '',
}

export default (ConfirmCheckbox)
